import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  CreditCard,
  Crown,
  ArrowLeft,
  LogOut,
  UserX,
  Ticket,
  BarChart3,
  Tags,
  TrendingUp,
  Clock,
  DollarSign,
  FileText,
  FolderOpen,
  UserCheck,
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';

const menuItems = [
  { title: 'Dashboard Master', url: '/master', icon: LayoutDashboard, end: true },
  { title: 'Conversão de Trials', url: '/master/trial-conversion', icon: TrendingUp },
  { title: 'Gestão de Trials', url: '/master/trials', icon: Clock },
  { title: 'Gestão de Pagamentos', url: '/master/payments', icon: DollarSign },
  { title: 'Logs de Sincronização', url: '/master/sync-logs', icon: FileText },
  { title: 'Usuários', url: '/master/users', icon: Users },
  { title: 'Sem Assinatura', url: '/master/users-without-subscription', icon: UserX },
  { title: 'Assinaturas', url: '/master/subscriptions', icon: CreditCard },
  { title: 'Planos', url: '/master/plans', icon: Crown },
  { title: 'Cupons', url: '/master/coupons', icon: Tags },
  { title: 'Vendedores', url: '/master/sales-reps', icon: UserCheck },
  { title: 'Comissões', url: '/master/commissions', icon: DollarSign },
  { title: 'Materiais Marketing', url: '/master/marketing-materials', icon: FolderOpen },
  { title: 'Tickets de Suporte', url: '/master/support-tickets', icon: Ticket },
  { title: 'Métricas de Suporte', url: '/master/support-metrics', icon: BarChart3 },
];

export function MasterSidebar() {
  const { state } = useSidebar();
  const collapsed = state === 'collapsed';
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="border-b">
        <div className="flex items-center gap-2 px-2 py-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-yellow-500 text-white">
            <Crown className="h-4 w-4" />
          </div>
          {!collapsed && (
            <div className="flex flex-col">
              <span className="text-sm font-semibold">Master Admin</span>
              <span className="text-xs text-muted-foreground">Techfix Pro</span>
            </div>
          )}
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Gerenciamento</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      end={item.end}
                      className={({ isActive }) =>
                        `flex items-center gap-2 w-full px-2 py-2 rounded-md transition-colors ${
                          isActive
                            ? 'bg-primary text-primary-foreground'
                            : 'hover:bg-muted'
                        }`
                      }
                    >
                      <item.icon className="h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="border-t space-y-1 p-2">
        <Button
          variant="ghost"
          className="w-full justify-start gap-2"
          size="sm"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft className="h-4 w-4" />
          {!collapsed && <span>Voltar ao Sistema</span>}
        </Button>
        <Button
          variant="ghost"
          className="w-full justify-start gap-2 text-destructive hover:text-destructive hover:bg-destructive/10"
          size="sm"
          onClick={async () => {
            await signOut();
            navigate('/auth?logout=true', { replace: true });
          }}
        >
          <LogOut className="h-4 w-4" />
          {!collapsed && <span>Sair</span>}
        </Button>
      </SidebarFooter>
    </Sidebar>
  );
}
